import { put, call, all, fork, takeEvery } from "redux-saga/effects";
import * as ProfileDetailsActions from "../actionTypes/profileDetailsActionTypes";
import * as ProfileDetailsActionCreators from "../actionCreators/profileDetailsActionCreators"
import { getAumMobile, getProfileDetails } from "../services/APIservice";
import { ARGO_SUCCESS, AUTH_KEY, NOT_AUTHORIZED_ERROR } from "../../constants/constants";
import { getTransactionIdFromURL, getValueFromLocalStorage, replaceValueFromLocalStorage } from "../../constants/utils";


function* getProfileDetailsInfo() {
  try {
    let txnId = getTransactionIdFromURL();
    yield put(ProfileDetailsActionCreators.getProfileDetailsRequest())
    let authKey = getValueFromLocalStorage(AUTH_KEY(txnId))
    if (authKey === null) {
      throw NOT_AUTHORIZED_ERROR
    }
    const { data, headers } = yield call(getProfileDetails);
    const { authorization } = headers;
    if (authorization !== null || authorization !== undefined) {
      replaceValueFromLocalStorage(AUTH_KEY(txnId), authorization)
    }
    if (data.code === ARGO_SUCCESS) {
      yield put(ProfileDetailsActionCreators.getProfileDetailsSuccess(data.data));
    } else {
      throw data
    }
  } catch (error) {
    if (error?.response?.data.status === NOT_AUTHORIZED_ERROR.code) {
      yield put(ProfileDetailsActionCreators.getProfileDetailsFailure(NOT_AUTHORIZED_ERROR))
    } else {
      yield put(ProfileDetailsActionCreators.getProfileDetailsFailure(error))
    }
  }
}


function* getAumProfileDetails() {
  try {
    let txnId = getTransactionIdFromURL()
    yield put(ProfileDetailsActionCreators.getAumDetailsRequest())
    let authKey = getValueFromLocalStorage(AUTH_KEY(txnId))
    if (authKey === null) {
      throw NOT_AUTHORIZED_ERROR
    }
    const { data, headers } = yield call(getAumMobile);
    const { authorization } = headers;
    if (authorization !== null || authorization !== undefined) {
      replaceValueFromLocalStorage(AUTH_KEY(txnId), authorization)
    }

    if (data.code === ARGO_SUCCESS) {
      yield put(ProfileDetailsActionCreators.getAumDetailsSuccess(data.data));
    } else {
      throw data
    }

  } catch (error) {
    if (error?.response?.data.status === NOT_AUTHORIZED_ERROR.code) {
      yield put(ProfileDetailsActionCreators.getAumDetailsFailure(NOT_AUTHORIZED_ERROR))
    } else {
      yield put(ProfileDetailsActionCreators.getAumDetailsFailure(error))
    }
  }
}

function* watchOnGetProfileDetails() {
  yield takeEvery(ProfileDetailsActions.GET_PROFILE_DETAILS, getProfileDetailsInfo)
}

function* watchOnGetAumDetails() {
  yield takeEvery(ProfileDetailsActions.AUM_MOBILE, getAumProfileDetails)
}

export default function* ProfileDetailsSaga() {
  yield all([
    fork(watchOnGetProfileDetails),
    fork(watchOnGetAumDetails)
  ])
}